import React from 'react';

const COLUMNS = [
  { key: 'todo',        label: 'À faire',   dot: 'var(--text-muted)', prev: null,      next: 'in-progress' },
  { key: 'in-progress', label: 'En cours',  dot: 'var(--accent)',     prev: 'todo',    next: 'done' },
  { key: 'done',        label: 'Terminées', dot: 'var(--success)',    prev: 'in-progress', next: null },
];

const PRI_COLOR = { high: 'var(--danger)', medium: 'var(--warning)', low: 'var(--success)' };
const PRI_LABEL = { high: '🔴 Haute', medium: '🟡 Moyenne', low: '🟢 Faible' };

export default function KanbanView({ tasks, onUpdate, onEdit, onDelete }) {
  const move = (task, newStatus) => {
    onUpdate(task._id, { status: newStatus });
  };

  return (
    <div className="kanban-board">
      {COLUMNS.map(col => {
        const colTasks = tasks.filter(t => t.status === col.key);
        return (
          <div key={col.key} className="kanban-column">
            <div className="kanban-col-header">
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <span className="kanban-col-dot" style={{ background: col.dot }} />
                {col.label}
              </span>
              <span className="kanban-col-count">{colTasks.length}</span>
            </div>
            <div className="kanban-col-body">
              {colTasks.length === 0 && (
                <div style={{ textAlign: 'center', padding: '1.5rem 0', color: 'var(--text-muted)', fontSize: '0.78rem' }}>
                  Aucune tâche ici
                </div>
              )}
              {colTasks.map(task => (
                <div key={task._id} className={`kanban-card priority-${task.priority}`}>
                  <div className="kanban-card-title">{task.title}</div>
                  <div className="kanban-card-meta">
                    <span className="badge" style={{ background: 'var(--bg-hover)', color: PRI_COLOR[task.priority], border: '1px solid var(--border)', fontSize: '0.68rem' }}>
                      {PRI_LABEL[task.priority]}
                    </span>
                    <span className="badge badge-category">{task.category}</span>
                  </div>
                  {task.dueDate && (
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: '0.4rem', fontFamily: 'JetBrains Mono' }}>
                      📅 {new Date(task.dueDate).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' })}
                    </div>
                  )}
                  <div className="kanban-move-btns">
                    {col.prev && (
                      <button className="kanban-move-btn" onClick={() => move(task, col.prev)} title={`Déplacer vers ${col.prev}`}>
                        ← Reculer
                      </button>
                    )}
                    <button className="kanban-move-btn" onClick={() => onEdit(task)} title="Modifier">
                      ✏️ Éditer
                    </button>
                    {col.next && (
                      <button className="kanban-move-btn" onClick={() => move(task, col.next)} title={`Déplacer vers ${col.next}`}
                        style={{ color: 'var(--accent)' }}>
                        Avancer →
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
